export enum DiscountType {
    ShippingDiscount = 130
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/discount-type.enum.ts